var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCallIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.20146 4.87299L9.79638 5.93901C10.3333 6.90104 10.1178 8.16305 9.27214 9.00865C9.27214 9.00865 8.24655 10.0344 10.1061 11.894C11.9651 13.753 12.9915 12.728 12.9915 12.728C13.8371 11.8824 15.0991 11.6669 16.0612 12.2038L17.1271 12.7987C18.5799 13.6094 18.7514 15.6466 17.4746 16.9235C16.7073 17.6908 15.7674 18.2878 14.7283 18.3271C12.9792 18.3935 10.0088 17.9508 7.02905 14.9711C4.04936 11.9914 3.60669 9.02096 3.673 7.27184C3.71239 6.2328 4.30939 5.29288 5.07665 4.52563C6.35352 3.24876 8.39073 3.42032 9.20146 4.87299Z",
    fill: "#B0B4C3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallIcon);
export default __webpack_public_path__ + "static/media/callIcon.041539c5aebcfd23a0442544b26b948a.svg";
export { ForwardRef as ReactComponent };